import React from "react";
import { FaAngleLeft } from "@react-icons/all-files/fa/FaAngleLeft";
import { FaAngleRight } from "@react-icons/all-files/fa/FaAngleRight";
import StripButton from "./strip-button";

function computeVisible(distance) {
  if (distance > 6) return "hidden 2xl:block";
  if (distance > 4) return "hidden xl:block";
  if (distance > 3) return "hidden md:block";
  if (distance > 1) return "hidden sm:block";
  return "";
}

export default function PaginatorLinks({
  children,
  current = 0,
  max = 0,
  onChange = () => {},
}) {
  const isMostLeft = current <= 0;
  const isMostRight = current >= max - 1;

  return (
    <div className="inline-flex w-auto -space-x-px">
      <StripButton
        onClick={() => onChange(current - 1)}
        className={isMostLeft ? "invisible" : ""}
        label="previous page"
      >
        <FaAngleLeft className="m-1" />
      </StripButton>

      {Array.from(Array(Number(max)).keys()).map((index) => (
        <StripButton
          key={index}
          index={index}
          selected={current === index}
          onClick={() => onChange(index)}
          className={`w-14 ${computeVisible(Math.abs(index - current))}`}
          label={`page ${Number(index) + 1}`}
        >
          <p>{Number(index) + 1}</p>
        </StripButton>
      ))}

      <StripButton
        onClick={() => onChange(current + 1)}
        className={isMostRight ? "invisible" : ""}
        label="next page"
      >
        <FaAngleRight className="m-1" />
      </StripButton>
    </div>
  );
}
